<div class="task">
  <div class="task__container">
    @if (task && taskAction) {
      <lib-task-header-info [task]="task" [taskTypeAction]="taskTypeAction" [recentTaskNote]="recentTaskNote">
      </lib-task-header-info>
      <div class="task-link__content">
        <div class="task-link__grid">
          <div class="col-3"></div>
          <div class="col-6">
            <div class="task-link__container">
              <div class="task-link__option" data-pw="task-link__container">
                <p class="task-link__instruction">
                  Please visit this link in order to complete this task.
                </p>
                <a
                  class="task-link__url"
                  [attr.href]="resolvedPageUrl || null"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-pw="task-link__url"
                  (click)="onLinkClick($event)">
                  {{ taskTypeAction?.customUrlLabel }}
                </a>
              </div>
            </div>
          </div>
          <div class="col-3"></div>
        </div>
      </div>
      <div class="button-row">
        <button
          aria-labelledby="Go Back Action"
          class="back-btn xlarge_button secondary_materials_button"
          color="primary"
          data-qa="upload_back_button"
          data-pw="upload_back_button"
          mat-stroked-button
          tabindex="0"
          (click)="onBack()"
          (keyup)="($event.key === 'Enter' || $event.key === ' ') && onBack()">
          <svg fill="none" height="14" viewBox="0 0 8 14" width="8" xmlns="http://www.w3.org/2000/svg" alt="Back">
            <path
              d="M0.381836 6.38213C0.0400391 6.72393 0.0400391 7.279 0.381836 7.6208L5.63184 12.8708C5.97363 13.2126 6.52871 13.2126 6.87051 12.8708C7.2123 12.529 7.2123 11.9739 6.87051 11.6321L2.23848 7.0001L6.86777 2.36807C7.20957 2.02627 7.20957 1.47119 6.86777 1.12939C6.52598 0.787598 5.9709 0.787598 5.6291 1.12939L0.379102 6.37939L0.381836 6.38213Z"
              fill="#003D57" />
          </svg>
          Back
        </button>
        <button
          aria-labelledby="Submit Upload Action"
          class="submit-btn primary_materials_button xlarge_button top-margin"
          data-pw="upload_submit_button"
          data-qa="upload_submit_button"
          mat-stroked-button
          color="accent"
          tabindex="0"
          [disabled]="!canSubmit"
          (click)="onSubmit()"
          (keyup)="($event.key === 'Enter' || $event.key === ' ') && onSubmit()">
          Submit
          <svg fill="none" height="14" viewBox="0 0 8 14" width="8" xmlns="http://www.w3.org/2000/svg" alt="submit">
            <path
              d="M7.66257 6.4468C7.96723 6.75145 7.96723 7.24409 7.66257 7.5455L1.43981 13.7715C1.13516 14.0762 0.642523 14.0762 0.341108 13.7715C0.039693 13.4669 0.036452 12.9742 0.341108 12.6728L6.0129 7.00101L0.337867 1.32598C0.033211 1.02133 0.033211 0.528693 0.337867 0.227278C0.642523 -0.0741368 1.13516 -0.0773778 1.43657 0.227278L7.66257 6.4468Z"
              [attr.fill]="!canSubmit ? '#C2C2C3' : 'white'" />
          </svg>
        </button>
      </div>
    }
  </div>
</div>
